<template>
  <span
    v-if="willSync"
    class="d-inline-flex align-center"
    :class="wrapperClass">
    <ac2-wms-status-button
      :synced="isSynced"
      :synced-at="ac2Sync && ac2Sync.updatedAt"
      :loading="syncing"
      :readonly="!isPending"
      readonly-text="(sync available only when pending)"
      @click="confirmSync()" />
  </span>
</template>

<script>
import { mapActions } from 'vuex'
import { getRole } from '@/assets/js/Authentication'
import { checkNoteWillSync } from '@/assets/js/Ac2NoteSync'
import InventoryProvider from '@/resources/InventoryProvider'
import Ac2WmsStatusButton from '@/components/Ac2WmsStatusButton.vue'

const InventoryService = new InventoryProvider()

export default {
  components: {
    Ac2WmsStatusButton
  },
  props: {
    note: {
      type: Object,
      required: true
    },
    // 'DeliveryNote' | 'WithdrawNote'
    type: {
      type: String,
      required: true
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    // fallback กรณี note ไม่มี status มาด้วย (ใช้ status ของ tab ที่เลือกอยู่)
    status: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      willSync: false,
      syncing: false
    }
  },
  computed: {
    ac2Sync () {
      return this.note?.ac2Sync || null
    },
    isPending () {
      // manual sync ใช้กรณี enqueue ตอนสร้าง DN/WN ผิดพลาด จึงกดได้เฉพาะ pending (ตรงกับ rule ฝั่ง backend)
      return (this.note?.status || this.status) === 'pending'
    },
    isSynced () {
      return !!(this.ac2Sync?.sync && this.ac2Sync?.ac2Log)
    },
    checkSignature () {
      const { note } = this
      return [
        this.type,
        note?.warehouse?.id,
        note?.withdrawNoteRef?.warehouseId,
        note?.deliveryNoteRef?.warehouseId,
        note?.reason
      ].join('|')
    }
  },
  watch: {
    checkSignature: {
      handler () {
        this.checkWillSync()
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal'
    }),
    async checkWillSync () {
      // ปุ่ม WMS เปิดให้เฉพาะ developer
      if (getRole() !== 'developer') {
        this.willSync = false
        return
      }

      const signature = this.checkSignature
      const willSync = await checkNoteWillSync(this.type, this.note)
      // กัน response เก่ามาทับ ถ้า note เปลี่ยนระหว่างรอ
      if (signature === this.checkSignature) {
        this.willSync = willSync
      }
    },
    confirmSync () {
      this.setModal({
        value: true,
        title: `Sync WMS ${this.note.code}`,
        message: `ต้องการส่ง ${this.note.code} เข้าคิว AC2 WMS ใช่หรือไม่ (ใช้กรณีส่งเข้าคิวอัตโนมัติไม่สำเร็จ)`,
        confirmText: 'Sync',
        confirmType: 'primary',
        cancelType: '',
        cancelText: 'Cancel',
        onConfirm: () => this.sync()
      })
    },
    async sync () {
      if (this.syncing || !this.isPending) {
        return
      }

      try {
        this.syncing = true

        const { data } = this.type === 'DeliveryNote'
          ? await InventoryService.syncDeliveryNoteToAc2(this.note.id)
          : await InventoryService.syncWithdrawNoteToAc2(this.note.id)

        this.setSnackbar({
          value: true,
          message: `ส่ง ${data?.documentNo || this.note.code} เข้าคิว Sync AC2 WMS สำเร็จ`,
          type: 'success'
        })
      } catch (error) {
        console.error('syncAc2', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.syncing = false
      }
    }
  }
}
</script>
